module.exports = __webpack_public_path__ + "static/media/support-icon-restaurant.7a577bac.svg";